<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'

const emit = defineEmits<{
  search: [query: string]
}>()

const { filters, setFilter } = useFilters()

const searchQuery = ref(filters.search || '')

// Debounced search with VueUse for better performance and cleanup
const debouncedSearch = useDebounceFn(() => {
  const trimmedQuery = searchQuery.value.trim()
  setFilter('search', trimmedQuery || undefined)
  emit('search', trimmedQuery)
}, 300)

const handleSearch = () => {
  debouncedSearch()
}

const handleClear = () => {
  searchQuery.value = ''
  setFilter('search', undefined)
  emit('search', '')
}

// Sync with URL changes
watch(() => filters.search, (newVal) => {
  if (newVal !== searchQuery.value) {
    searchQuery.value = newVal || ''
  }
})
</script>

<template>
  <div class="relative">
    <UInput
      v-model="searchQuery"
      placeholder="Buscar productos por nombre o código..."
      icon="i-heroicons-magnifying-glass"
      size="lg"
      class="w-full"
      @input="handleSearch"
      @keyup.enter="handleSearch"
    >
      <template v-if="searchQuery" #trailing>
        <UButton
          variant="ghost"
          color="neutral"
          size="xs"
          icon="i-heroicons-x-mark"
          aria-label="Limpiar búsqueda"
          @click="handleClear"
        />
      </template>
    </UInput>
  </div>
</template>
